// extracted by mini-css-extract-plugin
module.exports = {"container":"_1P0XY","mobile":"_8tQG8"};